exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-1ad93282] {\n  border-collapse: collapse;\n  width: 280px;\n  margin: 10px;\n  background-color: #fff;\n  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n}\nth[data-v-1ad93282],\ntd[data-v-1ad93282] {\n  text-align: left;\n  padding: 1rem;\n  border-bottom: 1px solid #ddd;\n}\nth[data-v-1ad93282] {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\ntr[data-v-1ad93282]:hover {\n  background-color: #f5f5f5;\n}\n[data-v-1ad93282] .v-dialog {\n  width: auto;\n}\n", ""]);

// exports
